/* eslint-disable no-underscore-dangle */
import FroalaEditor from 'froala-editor';
import VueFroala from 'vue-froala-wysiwyg';

import commands from './commands/index.js';
import inserts from './inserts.js';
import './plugins/word_counter.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/code_view.min.js';
import 'froala-editor/js/plugins/draggable.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/fullscreen.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/image_manager.min.js';
import 'froala-editor/js/third_party/image_tui.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/quick_insert.min.js';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/code_beautifier.min.js';
import { initialState } from '@/Helpers.js';

// Ensure global SVG gradient defs for Enhance icon are available when Froala loads
function ensureGlobalEnhanceGradientDefs() {
    if (typeof document === 'undefined' || document.getElementById('edv_enhance_svg_defs')) return;

    const svg = `
<svg id="edv_enhance_svg_defs" width="0" height="0" style="position:absolute;width:0;height:0;overflow:hidden" aria-hidden="true" focusable="false">
    <defs>
        <linearGradient id="edv_enhance_grad_global" x1="55.7085" y1="17.3062" x2="8.9872" y2="41.0376" gradientUnits="userSpaceOnUse">
            <stop stop-color="#00E8FD"></stop>
            <stop offset="0.497939" stop-color="#0000C9"></stop>
            <stop offset="1" stop-color="#9400C9"></stop>
        </linearGradient>
    </defs>
</svg>`;

    if (document.body) {
        document.body.insertAdjacentHTML('afterbegin', svg);
    } else {
        window.addEventListener('DOMContentLoaded', () => {
            if (!document.getElementById('edv_enhance_svg_defs')) {
                document.body.insertAdjacentHTML('afterbegin', svg);
            }
        });
    }
}

export default app => {
    ensureGlobalEnhanceGradientDefs();

    FroalaEditor.DefineIconTemplate('unicons', '<i class="uil uil-[NAME]"></i>');

    FroalaEditor.ICON_DEFAULT_TEMPLATE = 'unicons';

    // Special Icons
    FroalaEditor.DefineIconTemplate(
        'enhanceSvg',
        `
<svg xmlns="http://www.w3.org/2000/svg" class="fr-svg" width="24" height="24" viewBox="0 0 57 56" fill="none" aria-hidden="true" focusable="false">
    <path d="M15.9265 8.94685C16.5558 6.35192 20.2463 6.35192 20.8756 8.94684L22.6069 16.0869C22.8316 17.0134 23.5549 17.7368 24.4814 17.9614L31.6215 19.6928C34.2164 20.322 34.2164 24.0126 31.6215 24.6418L24.4814 26.3732C23.5549 26.5979 22.8316 27.3212 22.6069 28.2477L20.8756 35.3878C20.2463 37.9827 16.5558 37.9827 15.9265 35.3878L14.1952 28.2477C13.9705 27.3212 13.2471 26.5979 12.3207 26.3732L5.18057 24.6418C2.58564 24.0126 2.58564 20.322 5.18057 19.6928L12.3207 17.9614C13.2471 17.7368 13.9705 17.0134 14.1952 16.0869L15.9265 8.94685Z" style="fill: url(#edv_enhance_grad_global) !important" />
    <path d="M36.7116 33.865C37.0988 32.2681 39.3699 32.2681 39.7572 33.865L40.8226 38.2589C40.9609 38.829 41.406 39.2742 41.9761 39.4124L46.3701 40.4779C47.9669 40.8651 47.9669 43.1362 46.3701 43.5234L41.9761 44.5889C41.406 44.7271 40.9609 45.1723 40.8226 45.7424L39.7572 50.1363C39.3699 51.7332 37.0988 51.7332 36.7116 50.1363L35.6461 45.7424C35.5079 45.1723 35.0627 44.7271 34.4926 44.5889L30.0987 43.5234C28.5018 43.1362 28.5018 40.8651 30.0987 40.4779L34.4926 39.4124C35.0627 39.2742 35.5079 38.829 35.6461 38.2589L36.7116 33.865Z" style="fill: url(#edv_enhance_grad_global) !important" />
    <path d="M44.2351 8.66161C44.4892 7.61366 45.9796 7.61366 46.2337 8.66161L46.9329 11.5451C47.0236 11.9193 47.3158 12.2114 47.6899 12.3021L50.5734 13.0013C51.6214 13.2554 51.6214 14.7459 50.5734 15L47.6899 15.6992C47.3158 15.7899 47.0236 16.082 46.9329 16.4562L46.2337 19.3397C45.9796 20.3876 44.4892 20.3876 44.2351 19.3397L43.5358 16.4562C43.4451 16.082 43.153 15.7899 42.7788 15.6992L39.8953 15C38.8474 14.7459 38.8474 13.2554 39.8953 13.0013L42.7788 12.3021C43.153 12.2114 43.4451 11.9193 43.5358 11.5451L44.2351 8.66161Z" style="fill: url(#edv_enhance_grad_global) !important" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M45.2344 9.1732L44.6637 11.5267C44.4356 12.4674 43.7011 13.2019 42.7604 13.43L40.4069 14.0007L42.7604 14.5713C43.7011 14.7994 44.4356 15.5339 44.6637 16.4747L45.2344 18.8281L45.8051 16.4747C46.0332 15.5339 46.7677 14.7994 47.7084 14.5713L50.0618 14.0007L47.7084 13.43C46.7677 13.2019 46.0332 12.4674 45.8051 11.5267L45.2344 9.1732ZM46.3765 7.89889C46.0861 6.70124 44.3827 6.70124 44.0923 7.8989L43.2932 11.1943C43.1895 11.6219 42.8557 11.9558 42.4281 12.0595L39.1326 12.8586C37.935 13.149 37.935 14.8523 39.1326 15.1427L42.4281 15.9418C42.8557 16.0455 43.1895 16.3794 43.2932 16.807L44.0923 20.1024C44.3827 21.3001 46.0861 21.3001 46.3765 20.1024L47.1756 16.807C47.2792 16.3794 47.6131 16.0455 48.0407 15.9418L51.3361 15.1427C52.5338 14.8523 52.5338 13.149 51.3361 12.8586L48.0407 12.0595C47.6131 11.9558 47.2792 11.6219 47.1756 11.1943L46.3765 7.89889Z" style="fill: url(#edv_enhance_grad_global) !important" />
    <path d="M17.2344 53.6673C15.9457 53.6673 14.901 52.6227 14.901 51.334C14.901 50.0453 15.9457 49.0007 17.2344 49.0007C18.523 49.0007 19.5677 50.0453 19.5677 51.334C19.5677 52.6227 18.523 53.6673 17.2344 53.6673Z" style="fill: url(#edv_enhance_grad_global) !important" />
    <path d="M5.56771 44.334C4.27904 44.334 3.23437 43.2893 3.23438 42.0007C3.23438 40.712 4.27904 39.6673 5.56771 39.6673C6.85637 39.6673 7.90104 40.712 7.90104 42.0007C7.90104 43.2893 6.85637 44.334 5.56771 44.334Z" style="fill: url(#edv_enhance_grad_global) !important" />
    <path d="M31.2344 7.00065C29.9457 7.00065 28.901 5.95598 28.901 4.66732C28.901 3.37865 29.9457 2.33398 31.2344 2.33398C32.523 2.33398 33.5677 3.37865 33.5677 4.66732C33.5677 5.95598 32.523 7.00065 31.2344 7.00065Z" style="fill: url(#edv_enhance_grad_global) !important" />
    <path d="M52.2344 32.6673C50.9457 32.6673 49.901 31.6227 49.901 30.334C49.901 29.0453 50.9457 28.0007 52.2344 28.0007C53.523 28.0007 54.5677 29.0453 54.5677 30.334C54.5677 31.6227 53.523 32.6673 52.2344 32.6673Z" style="fill: url(#edv_enhance_grad_global) !important" />
</svg>`
    );

    FroalaEditor.DefineIcon('enhance', { template: 'enhanceSvg' });

    // Custom Primary Toolbar Icons
    FroalaEditor.DefineIcon('formatOL', { NAME: 'list-ui-alt' });
    FroalaEditor.DefineIcon('subscript', { NAME: 'angle-down' });
    FroalaEditor.DefineIcon('superscript', { NAME: 'angle-up' });
    FroalaEditor.DefineIcon('outdent', { NAME: 'left-indent-alt' });
    FroalaEditor.DefineIcon('indent', { NAME: 'right-indent-alt' });
    FroalaEditor.DefineIcon('quote', { NAME: 'comment-alt-lines' });
    FroalaEditor.DefineIcon('inlineClass', { NAME: 'palette' });
    FroalaEditor.DefineIcon('insertVideo', { NAME: 'video' });
    FroalaEditor.DefineIcon('videoEmbed', { NAME: 'image-upload' });
    FroalaEditor.DefineIcon('undo', { NAME: 'corner-left-down' });
    FroalaEditor.DefineIcon('redo', { NAME: 'corner-right-down' });
    FroalaEditor.DefineIcon('clearFormatting', { NAME: 'ban' });
    FroalaEditor.DefineIcon('fullscreen', { NAME: 'expand-arrows-alt' });
    FroalaEditor.DefineIcon('html', { NAME: 'arrow' });

    // Custom Image Pop-up Icons
    FroalaEditor.DefineIcon('imageCaption', { NAME: 'picture' });
    FroalaEditor.DefineIcon('imageDisplay', { NAME: 'document-layout-left' });
    FroalaEditor.DefineIcon('imageStyle', { NAME: 'image-edit' });
    FroalaEditor.DefineIcon('imageAlt', { NAME: 'image-redo' });
    FroalaEditor.DefineIcon('imageSize', { NAME: 'image-resize-landscape' });
    FroalaEditor.DefineIcon('imageTUI', { NAME: 'image-edit' });

    // Custom Video Pop-up Icons
    FroalaEditor.DefineIcon('videoDisplay', { NAME: 'document-layout-left' });
    FroalaEditor.DefineIcon('videoSize', { NAME: 'image-resize-landscape' });

    // Custom Table Pop-up Icons
    FroalaEditor.DefineIcon('tableHeader', { NAME: 'text' });
    FroalaEditor.DefineIcon('tableColumns', { NAME: 'columns' });
    FroalaEditor.DefineIcon('tableStyle', { NAME: 'border-alt' });
    FroalaEditor.DefineIcon('tableCells', { NAME: 'th' });
    FroalaEditor.DefineIcon('tableCellBackground', { NAME: 'brush-alt' });
    FroalaEditor.DefineIcon('tableCellStyle', { NAME: 'border-inner' });

    // Custom More Icons
    FroalaEditor.DefineIcon('moreText', { NAME: 'text' });
    FroalaEditor.DefineIcon('moreParagraph', { NAME: 'align-center' });
    FroalaEditor.DefineIcon('moreRich', { NAME: 'images' });
    FroalaEditor.DefineIcon('moreMisc', { NAME: 'ellipsis-v' });

    // Add an option for your plugin.
    FroalaEditor.DEFAULTS = Object.assign(FroalaEditor.DEFAULTS, {
        myOption: false,
    });

    // Override defaults
    FroalaEditor.COMMANDS.inlineClass.title = 'Text Styles';

    // Register commands
    Object.keys(commands).forEach(command => FroalaEditor.RegisterCommand(command, commands[command]));

    // Loop through provided inserts and register icons and commands for them.
    for (let i = 0; i < inserts.length; i++) {
        FroalaEditor.DefineIcon(inserts[i].command, { NAME: inserts[i].icon });

        FroalaEditor.RegisterCommand(inserts[i].command, {
            title: inserts[i].title,
            icon: inserts[i].command,
            undo: true,
            focus: true,
            showOnMobile: true,
            refreshAfterCallback: true,
            callback() {
                this.html.insert(inserts[i].commandHtml);
            },
        });
    }

    FroalaEditor.PLUGINS.imageFallbackOnError = function imageFallbackOnError(editor) {
        function _init() {
            editor.events.on('image.inserted', function imageInserted($img, response) {
                const data = JSON.parse(response);

                $img.attr('onerror', `this.onerror=null; this.src='${data['data-fallback']}';`);
            });
        }

        return { _init };
    };

    window.WEBSPELLCHECKER_CONFIG = {
        autoSearch: true,
        autoDestroy: true,
        serviceId: initialState('Froala.spellchecker_key'),
    };

    app.use(VueFroala);
};
